import Vue from 'vue'
import ClickOutside from 'vue-click-outside'
import { defineNuxtPlugin } from '@nuxtjs/composition-api'

export default defineNuxtPlugin(() => {
  Vue.directive('click-outside', ClickOutside)
})
